import { Outlet } from "react-router-dom";

const Frontend = () => {
	return (
		<div className="container">
			<Outlet />
		</div>
	);
};

export default Frontend;
